import React from 'react'
import { LetterContainer } from './LetterContainer'
import { Definition } from '@/components/Card/Definition'
import { VStack, Flex } from '@chakra-ui/react'
import type { Glossary } from '@/types/glossary'

type MobileProps = {
  availableLetters: string[]
  itemsDict: { [key: string]: Glossary[] }
  selectedLetter: string
  setSelectedLetter: (val: string) => void
}

export const Mobile = ({
  availableLetters,
  itemsDict,
  selectedLetter,
  setSelectedLetter,
}: MobileProps) => {
  return (
    <>
      <LetterContainer
        availableLetters={availableLetters}
        selectedLetter={selectedLetter}
        setSelectedLetter={setSelectedLetter}
      />
      <VStack alignItems={'flex-start'} my={8}>
        {availableLetters.map((letter, index) => {
          return (
            <VStack id={index === 0 ? '#' : letter} w={'100%'}>
              {itemsDict[letter].map(({ slug, title, acf }) => (
                <Flex
                  border={'1px solid #EAEEF4'}
                  borderRadius={'12px'}
                  background={'white'}
                  paddingX={16}
                  paddingY={12}
                  width={[327, null, 695, null]}
                >
                  <Definition
                    slug={slug}
                    name={title}
                    shortDescription={acf.short_description}
                  />
                </Flex>
              ))}
            </VStack>
          )
        })}
      </VStack>
    </>
  )
}
